import { render } from "./IconRssFeed.vue?vue&type=template&id=0de83eb6"
import script from "./IconRssFeed.vue?vue&type=script&lang=js"
export * from "./IconRssFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__